/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_CopiedInputs */

const en_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied!`)
};

const ar_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم النسخ!`)
};

const bn_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কপি হয়েছে!`)
};

const de_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert!`)
};

const es_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Copiado!`)
};

const fr_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`copié!`)
};

const pt_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado!`)
};

const zh_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制！`)
};

const tr_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyalandı!`)
};

const ru_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано!`)
};

const pl_copy_copied = /** @type {(inputs: Copy_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiowano!`)
};

/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Copy_CopiedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const copy_copied = /** @type {((inputs?: Copy_CopiedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_CopiedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_copy_copied(inputs)
	if (locale === "bn") return bn_copy_copied(inputs)
	if (locale === "de") return de_copy_copied(inputs)
	if (locale === "es") return es_copy_copied(inputs)
	if (locale === "fr") return fr_copy_copied(inputs)
	if (locale === "pt") return pt_copy_copied(inputs)
	if (locale === "zh") return zh_copy_copied(inputs)
	if (locale === "tr") return tr_copy_copied(inputs)
	if (locale === "ru") return ru_copy_copied(inputs)
	if (locale === "pl") return pl_copy_copied(inputs)
	return en_copy_copied(inputs)
});